module.exports = __webpack_public_path__ + "static/dribbble-2dfc0c1930539506bab1f9c2c8dd1cbf.png";